import { User } from '../types';

/** Active tenant (handles legacy 0/1 from API). */
export function isActiveTenant(t: User): boolean {
  if (t.isDeleted) return false;
  const v = t.isActive as boolean | number | string | undefined;
  if (v === false || v === 0 || v === '0' || v === 'false') return false;
  return Boolean(v);
}

export function isTenantOnVacatingNotice(t: User): boolean {
  return isActiveTenant(t) && Boolean(t.isNotice);
}
